import createSpacing from './createSpacing';
import createBreakpoints from './createBreakpoints';
import createShadows from './createShadows';
import createTypography from './createTypography';
import createMixins from './createMixins';
import hex2rgba from './hex2rgba';

const theme = {
  error: '#DA1E28',
  modalBorder: '#E3E5E8',
  inputBorder: '#C6C9CD',
  blue01: '#F2FBFE',
  blue02: '#CAEEFC',
  blue03: '#A2E2FA',
  blue04: '#79D5F7',
  blue05: '#51C8F5',
  blue06: '#29BCF2',
  blue07: '#00AFF0',
  blue08: '#019DDA',
  blue09: '#027BAF',
  blue10: '#006B9A',
  blue11: '#025B84',
  blue12: '#024A6E',
  blue13: '#003D59',
  blue14: '#002D43',
  blue15: '#001E2E',
  blue16: '#001018',
  grey01: '#EFF3F5',
  grey02: '#E5E8ED',
  grey03: '#D2D7DF',
  grey04: '#C0C7D1',
  grey05: '#AEB6C2',
  grey06: '#9DA6B3',
  grey07: '#8C95A3',
  grey08: '#7C8593',
  grey09: '#6D7684',
  grey10: '#5E6774',
  grey11: '#4F5864',
  grey12: '#414954',
  grey13: '#333A44',
  grey14: '#262B33',
  grey15: '#181C21',
  grey16: '#0B0D10',
  link: '#008ABD',
  boxShadow: '0 0 5px 0 #17191D',
  menuBackground: '#F5F8FA',
  menuLink: '#f5f6f9',
  white: '#ffffff',
  yellow: '#FDD13A',
  orange: '#FC7B1E',
  black: '#000000',
  green: '#24A249',
  emptyState: '#003862',
  fontSize: '16px',
  fontFamily: '"Roboto", sans-serif',
  fontFamilyFeature: '"PF Benchmark Pro", serif',
  weightBlack: 900,
  bold: 700,
  medium: 500,
  regular: 400,
  transitionEasing: '.2s ease-in-out',
  mainButtonTextShadow: '#038cbe',
  gradients: {
    main: 'linear-gradient(180deg, #00b0f0 0%, #049cd4 50%, #0488b9 100%)',
    success: 'linear-gradient(180deg, #00aff0 0%, #019dda 100%)',
  },
  contentMaxWidth: '1272px',
  contentMaxWidthValue: '1272',
  kambiHover: '#f5f5f5',
  z: {
    modal: 600,
    modalPage: 500,
    pageNotification: 400,
  },
  spacing: createSpacing(),
  breakpoints: createBreakpoints({}),
  shadows: createShadows(),
  typography: createTypography(),
  mixins: createMixins(),
  text: {
    primary: '#003D59',
    secondary: '#fff',
    tertiary: '#7C8593',
  },
  navIcons: {
    disabled: '#4C616D',
    main: '#99A5AB',
    active: '#00AFF0',
  },
  colors: {
    accent: {
      main: '#FDD13A',
    },
    warning: {
      main: '#FC7B1E',
    },
    error: {
      main: '#DA1E28',
    },
    success: {
      main: '#24A249',
    },
    link: {
      main: '#00AFF0',
      hover: '#29BCF2',
      visited: '#027BAF',
    },
  },
  dialog: {
    borderRadius: '4px',
    boxShadow: `0 10px 30px 0 rgba(0,0,0,.3)`,
  },
  hex2rgba,
};

export default function createTheme() {
  return theme;
}
